<template lang="pug">
  li(:class="tabMeta.tabEl.tabClass")
    a(href="#" @click.prevent="onClick") {{tabMeta.title}}

</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component({
  name: 'regular-tab-nav-button',
})
export default class RegularTabNavButton extends Vue {
  @Prop({required: true})
  tabMeta!: any

  onClick(/* event: any */) {
    this.$emit('tab-click', this.tabMeta.id);
  }
}
</script>

<style scoped lang="less">

</style>
